import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
// Create your Material-UI theme
const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
        },
        secondary: {
            main: '#dc004e',
        },
    },
    typography: {
        fontFamily: 'Roboto, Arial, sans-serif',
    },
});
const ThemeWrapper = ({ children }) => {
    return _jsx(ThemeProvider, { theme: theme, children: children });
};
export default ThemeWrapper;
